<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0" @click.prevent="openAddDialog" icon="pi pi-plus" label="NEW" />
        </div>
      </div>
      <Dialogs header="Activity/Task" :visible.sync="addDisplayBasic" :style="{width: '50vw', maxHeight: '90vh'}"
        :modal="true" :closable=false :contentStyle="{'overflow-y': 'auto', 'max-height': '70vh'}">
        <div class="p-fluid p-formgrid p-grid">
          <!-- <div class="p-field p-col-12 p-md-6">
            <label for="taskType">Activity Type <span style="color:red">*</span></label>
            <Dropdown v-model="taskType" :options="activityTypeOptions" optionLabel="label" 
              optionValue="value" placeholder="Select Activity Type" />
          </div> -->
          <div class="p-field p-col-12 p-md-6">
            <label for="source">Activity Type</label>
            <Dropdown 
              id="source" 
              v-model="taskType" 
              :options="sourceList" 
              optionLabel="value" 
              placeholder="Select Activity Type" />
          </div>
          <!-- if task type is call -->
          <div class="p-field p-col-12 p-md-6" v-if="taskType && taskType.value === 'call'">
            <label for="callTypeId">Call type<span style="color:red">*</span></label>
            <Dropdown v-model="callType" :options="callTypeOptions" optionLabel="label" 
              optionValue="value" placeholder="Select Call Type" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="taskname">Task Name<span style="color:red">*</span></label>
            <InputText id="taskname" v-model.trim="taskName" />
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="clientid">Client Id</label>
            <InputText @keypress="isNumber($event)" v-model="clientId" id="clientid"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="taskDueDate">Task Due Date</label>
            <InputMask @keypress="isNumber($event)" mask="9999-99-99" v-model="taskDueDate" id="taskDueDate"/>
          </div>
          
          <div class="p-field p-col-12 p-md-6">
            <label for="productId">Product</label>
            <InputText v-model.trim="productId" id="productId" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="stageId">Stage Id</label>
            <InputText v-model.trim="stageId" id="stageId" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="taskStatus">Status</label>
            <InputText v-model.trim="taskStatus" id="taskStatus"/>
          </div>

          <!-- <div class="p-field p-col-12 p-md-6">
            <label for="priorityId">Priority</label>
            <InputText v-model.trim="priorityId" id="priorityId" />
          </div> -->
          <div class="p-field p-col-12 p-md-6">
            <label for="priority">Priority</label>
            <Dropdown 
              id="priority" 
              v-model="priorityName" 
              :options="priorityList" 
              optionLabel="value" 
              placeholder="Select Priority" />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="repeat">Repeat</label>
            <InputText v-model.trim="repeat" id="repeat" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="reminderType">reminderType</label>
            <InputText v-model.trim="reminderType" id="reminderType" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="reminderDate">Reminder Date</label>
            <InputMask mask="9999-99-99" v-model.trim="reminderDate" id="reminderDate" />
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="reminderTime">Reminder Time</label>
            <DatePicker 
              v-model="reminderTime" 
              type="time" 
              id="reminderTime"
              placeholder="Select time (HH:mm)"
              :time-picker-options="{
                start: '08:00',
                step: '00:30',
                end: '20:00'
              }"
              format="HH:mm"
              value-type="format"
            />
            <small class="p-d-block p-mt-1 p-text-secondary">
              Enter time in 24-hour format (e.g., 14:30)
            </small>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label for="description">Description</label>
            <Textarea id="description" rows="3" v-model="description" style="resize: vertical; min-height: 75px; max-height: 150px;"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button" @click.prevent="addProduct" :label="editing?'Update':'Add'"/>
          <Button class="p-button-raised p-button-primary" label="Add & New" @click.prevent="addAndNewProduct" v-if="!editing"/>
          <Button @click.prevent="addCancel" class="p-button-raised p-button-danger" label="Cancel"/>
        </template>
      </Dialogs>
    </form>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import Dropdown from 'primevue/dropdown'
import RadioButton from 'primevue/radiobutton'
import Dialogs from 'primevue/dialog'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea/Textarea'
export default {
  name: 'supplier',
  data() {
    return {
      taskType: null,
      priorityName: null,
      callType: '',
      taskName: '',
      priorityId: '',
      productId: '',
      taskStatus: '',
      stageId: '',
      repeat: '',
      taskDueDate: '',
      reminderType: '',
      reminderDate: '',
      reminderTime: '',
      clientId: '',
      description: '',
      dialogShow: false,
      addDisplayBasic: false,
      addDialog: false,
      editing: false,
      status: 'ACTIVE',
      id: '',
      loading: false,
      columnList: '',
      callTypeOptions: [
        { label: 'Low', value: 0 },
        { label: 'High', value: 1 }
      ],
      filters: {}
    }
  },
  methods: {
    async addProduct() {
      if (this.taskType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Activity type cannot be empty!', life: 10000})
        return
      }
      if (this.taskName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'taskName cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        id: this.id,
        taskType: this.taskType.id,
        taskTypeName: this.taskType.value,
        callType: this.callType,
        taskName: this.taskName,
        priorityId: this.priorityName.id,
        priorityName: this.priorityName.value,
        productId: this.productId,
        taskStatus: this.taskStatus,
        stageId: this.stageId,
        repeat: this.repeat,
        taskDueDate: this.taskDueDate,
        reminderType: this.reminderType,
        reminderDate: this.reminderDate,
        reminderTime: this.reminderTime,
        clientId: this.clientId,
        description: this.description
      }
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createCrmTask', accountMaster)
        // this.$emit('set_supplier_master', resp.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateCrmTask', accountMaster)
        this.loading = false
      }
      this.responseMessage(resp)
      this.closeAddDialog()
    },
    async addAndNewProduct() {
      if (this.taskType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Activity type cannot be empty!', life: 10000})
        return
      }
      if (this.taskName === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'taskName cannot be empty!', life: 10000})
        return
      }
      let resp = ''
      let accountMaster = {
        taskType: this.taskType.id,
        taskTypeName: this.taskType.value,
        callType: this.callType,
        taskName: this.taskName,
        priorityId: this.priorityName.id,
        priorityName: this.priorityName.value,
        productId: this.productId,
        taskStatus: this.taskStatus,
        stageId: this.stageId,
        repeat: this.repeat,
        taskDueDate: this.taskDueDate,
        reminderType: this.reminderType,
        reminderDate: this.reminderDate,
        reminderTime: this.reminderTime,
        clientId: this.clientId,
        description: this.description
      }
      this.loading = !this.loading
      resp = await this.$store.dispatch('createCrmTask', accountMaster)
      this.loading = false
      this.responseMessage(resp)
    },
    responseMessage(resp) {
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
        this.editing = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    editCrmTask(data) {
      this.addDialog = true
      this.id = data.id
      this.editing = true
      this.taskType = this.sourceList.find(item => item.id === data.taskType)
      if (this.taskType && this.taskType.value === 'call') {
        this.callType = data.callType
      } else {
        this.callType = ''
      }
      this.taskName = data.taskName
      this.priorityName = this.priorityList.find(item => item.id === data.priorityId)
      this.priorityId = data.priorityId
      this.productId = data.productId
      this.taskStatus = data.taskStatus
      this.stageId = data.stageId
      this.repeat = data.repeat
      this.taskDueDate = data.taskDueDate
      this.reminderType = data.reminderType
      this.reminderDate = data.reminderDate
      this.reminderTime = data.reminderTime
      this.clientId = data.clientId
      this.description = data.description
      this.openAddDialog()
    },
    reset() {
      this.taskType = null
      this.priorityName = null
      this.callType = ''
      this.taskName = ''
      this.priorityId = ''
      this.productId = ''
      this.taskStatus = ''
      this.stageId = ''
      this.repeat = ''
      this.taskDueDate = ''
      this.reminderType = ''
      this.reminderDate = ''
      this.reminderTime = ''
      this.clientId = ''
      this.description = ''
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    addCancel() {
      this.reset()
      this.closeAddDialog()
    }
  },
  watch: {
    taskType(newVal) {
      if (newVal && newVal.value !== 'call') {
        this.callType = ''
      }
    }
  },
  computed: {
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    priorityList() {
      return this.masterSetupList.filter(item =>
        item.name === 'priority'
      )
    },
    sourceList() {
      return this.masterSetupList.filter(item =>
        item.name === 'source'
      )
    }
  },
  mounted() {
    this.masterSetupLists()
  },
  components: {
    Dropdown,
    RadioButton,
    Dialogs,
    Toast,
    Button,
    InputText,
    InputMask,
    Textarea,
    DatePicker
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// crmTaskDialog.vue?bd1fb140